import { useContext } from 'react';
import { useIsDealershipPage } from '~/context/dealership/StaticContext';
import UnlockTimerContext from '~/context/vdp/UnlockTimerContext';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import useAlertStatus from '~/hooks/vdp/selectors/useAlertStatus';
import useIsInExclusivePreview from '~/hooks/vdp/selectors/useIsInExclusivePreview';
import useIsWipVehicleReservedByUser from '~/hooks/vdp/selectors/useIsWipVehicleReservedByUser';

export default function useShouldRenderCondensedHero() {
  const {
    isSold: isAvailabilitySold,
    otherUnavailable,
    purchasePending,
    unavailable
  } = useAlertStatus();
  const { shouldShowTimer } = useContext(UnlockTimerContext);
  const { saleStatus } = useGetVehicleDetails();
  const isDealership = useIsDealershipPage();
  const isInExclusivePreview = useIsInExclusivePreview();
  const isWipReservedByUser = useIsWipVehicleReservedByUser();

  const isSaleStatusSold = saleStatus === 'Sold';
  // Availability is called on the client and sale status from Vehicle Details on the server
  const isSold = isAvailabilitySold || isSaleStatusSold;

  return (
    !isDealership &&
    !isInExclusivePreview &&
    ((purchasePending && !shouldShowTimer) ||
      isSold ||
      ((otherUnavailable || unavailable) && !isWipReservedByUser))
  );
}
